export default "__VITE_ASSET__BmcQZL$F__"